import { render, staticRenderFns } from "./FormUploadCopyModal.vue?vue&type=template&id=6c702aaa"
import script from "../../../scripts/partials/FormUploadCopyModal.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/FormUploadCopyModal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports